import { Outlet, useLocation } from 'react-router-dom';
import RecentlyViewed from './RecentlyViewed';
import LikedVideos from './LikedVideos';
import { useSessionContext } from 'supertokens-auth-react/recipe/session';
import { usePageTitle } from 'lib/pageTitle';

export default function ContentLayout() {
    const { pathname } = useLocation();
    const isVideo = pathname.includes('video');
    const isAdmin = pathname.includes('admin');
    const session = useSessionContext();
    const loggedIn = session.doesSessionExist;
    const { pageTitle } = usePageTitle();

    return (
        <div
            className={`grid grid-cols-1 gap-4 sm:gap-6 lg:grid-cols-12 lg:gap-8 ${isVideo ? 'px-1' : 'px-1 sm:px-2 lg:px-8'
                }`}>
            <div className={isVideo || isAdmin ? 'lg:col-span-12' : 'lg:col-span-9'}>
                <Outlet />
            </div>
            {!isAdmin && (
                <div className="lg:col-span-3">
                    <RecentlyViewed name={pageTitle} />
                    {loggedIn && <LikedVideos />}
                </div>
            )}
        </div>
    );
}
